"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const Radio = ({ id: givenId, hiddenLabel = false, inline = false, boundingBox = false, children, className, ...otherProps }) => {
    const generatedId = (0, react_1.useId)();
    const id = givenId || generatedId;
    if (hiddenLabel && !otherProps["aria-label"]) {
        throw new Error(`Missing aria-label in component#${id} with hidden label`);
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)({ "dds-radio__bounding-box": boundingBox }, { "dds-radio__inline": inline }), children: [(0, jsx_runtime_1.jsx)("input", { className: "dds-radio__input", id: id, type: "radio", ...otherProps }), (0, jsx_runtime_1.jsx)("label", { className: (0, classnames_1.default)({ "dds-radio": true }, { "dds-radio--hidden-label": hiddenLabel }, className), htmlFor: id, children: !hiddenLabel && children })] }));
};
exports.default = Radio;
//# sourceMappingURL=Radio.js.map